import React, { useState, useEffect } from "react";

const ProfileImage = ({ imageProfileUrl, defaultImage }) => {
    const [userImage, setUserImage] = useState(defaultImage);

    useEffect(() => {
        if (!imageProfileUrl) return;
        const img = new Image();
        img.src = imageProfileUrl;
        img.onload = () => setUserImage(imageProfileUrl);
        img.onerror = () => setTimeout(() => { setUserImage(defaultImage); }, [1000])
    }, [imageProfileUrl]);

    return <img className="icon" src={userImage} alt="hunt-icon" style={{ filter: "brightness(0) saturate(100%) invert(37%)" }} />;
};

export default ProfileImage;
